import * as React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Reclamation } from './iMonCompte';
import { renderAlert, renderFilArianne, renderTitleH1 } from './RenderCommon';
import { getUserId, sessionExpire } from './MonCompteAction';
import {getHostApi, getRequestConfig, initEvent} from '../../utils';
import RenderReclamationDetails from './RenderReclamationDetails';

interface RenderReclamationsState {
  orderId: number;
  reclamations: Reclamation[];
  showAlert: boolean;
  textAlert: string;
  transporteurNameSelect?: string;
  classAlert: string;
  open: boolean;
  openPr: boolean;
  openDetails: boolean;
  cancelReclamationId: string;
}

export default class RenderReclamations extends React.Component<Record<string, any>, RenderReclamationsState> {
  constructor(props: any) {
    super(props);
    this.state = {
      orderId: props.match.params.id,
      reclamations: [],
      showAlert: false,
      textAlert: 'Votre demande de réclamation a bien été annulée',
      classAlert: 'alert-success',
      open: false,
      openPr: false,
      openDetails: false,
      cancelReclamationId: '',
    };
  }

  componentWillMount() {
    this._getOrderReclamations();
  }

  _getOrderReclamations() {
    document.dispatchEvent(initEvent('dp-loading'));
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/`,
        getRequestConfig()).then((response) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (response.data.retours) {
        this.setState({
          reclamations: response.data.retours,
        });
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  onOpenModalPr = () => {
    this.setState({ openPr: true });
  }

  onCloseModalPr = () => {
    this.setState({ openPr: false });
  }

  onShowAlert = () => {
    this.setState({ showAlert: true }, () => {this._getOrderReclamations()});
    return true;
  }

  onClickButton = (event: React.MouseEvent<HTMLButtonElement>, reclamationId: string) => {
    // event.preventDefault();
    this.setState({ cancelReclamationId: reclamationId });
    this.onOpenModal();
  }

  _onGenerateColis = (index: number) => {
    const reclamations = [...this.state.reclamations];
    const reclamation = reclamations[index];
    const transporteurLength = reclamation.transporteurs.length;
    let response = false;
    let nbrEtiquetteTxt = '1 étiquette';
    let nbrColis = 1;

    if (reclamation.nb_colis && reclamation.nb_colis > 1) {
      nbrEtiquetteTxt = reclamation.nb_colis + ' étiquettes';
      nbrColis = reclamation.nb_colis;
    }

    if (transporteurLength >= 2 && reclamation.attente_client == 'Remboursement' &&
      reclamation.remboursement.fraisTransporteur && reclamation.remboursement.fraisTransporteur != '0.00') {
      response = confirm('Confirmez-vous la génération de ' + nbrEtiquetteTxt + ' ' + reclamation.transporteur_name +
        '  ? \n(Frais de transport déduits de votre remboursement de ' + reclamation.remboursement.fraisTransporteurTTC
        + '€). ');
    } else if (nbrColis > 1) {
      response = confirm('Confirmez-vous le retour de ' + nbrColis + ' colis ?');
    } else {
      response = confirm('Confirmez-vous le retour de ' + nbrColis + ' colis ? ');
    }
    if (response == true) {
      document.dispatchEvent(new Event('dp-loading'));
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/${reclamation.id}/etiquettes`;

      axios.post(url, { quantity: reclamation.nb_colis, transporteur_id: reclamation.transporteur_id }, getRequestConfig())
        .then((response) => {
        document.dispatchEvent(new Event('dp-loaded'));
        const url = response.data.url;

        window.location.href = '/' + url;
      }).catch((error) => {
        document.dispatchEvent(new Event('dp-loaded'));
        console.log(error);
      });
    }
  }

  _onNbColisChanged = (qte: number, index: number) => {
    const reclamations = [...this.state.reclamations];
    reclamations[index].nb_colis = qte;

    this.setState({
      reclamations: reclamations,
    });
  }

  _onTransporteurChanged = (transporteurId: string, index: number) => {
    const reclamations = [...this.state.reclamations];
    reclamations[index].transporteur_id = transporteurId;
    const reclamation = reclamations[index];
    let transporteur = null;

    for (const item of reclamation.transporteurs) {
      if (item.id == transporteurId) {
        transporteur = item;
      }
    }

    reclamations[index].transporteur_name = transporteur?.nom as string;

    if (transporteur && reclamation.remboursement) {
      const remboursementHt = (reclamation.remboursement.totalRemboursementHT - transporteur.prix);
      const montantTva = remboursementHt * (reclamation.remboursement.tauxTva / 100);

      const ttc: any = remboursementHt + montantTva;
      reclamations[index].remboursement.totalRemboursementTTC = parseFloat(ttc).toFixed(2);
      reclamations[index].remboursement.fraisTransporteur = transporteur.prix;
      reclamations[index].remboursement.fraisTransporteurTTC =
        parseFloat((transporteur.prix * (reclamation.remboursement.tauxTva / 100 + 1)) as any).toFixed(2);
    }
    this.setState({
      reclamations: reclamations,
    });
  }

  render() {
    const renderListReclamations = this.state.reclamations.map((reclamation: Reclamation) => {
      return (
        <div key={`reclamations-${reclamation.id}`} className="row-reclamation p-3">
          <RenderReclamationDetails reclamation={reclamation} orderId={this.state.orderId} refresh={() => {
            return this.onShowAlert();}}/>
        </div>
      );
    });

    return (
      <div>
        <div>
          {renderTitleH1('carnet', 'Mes réclamations')}
        </div>
        {renderFilArianne(<Link className="grey" to={`/orders`}>Mes commandes</Link>,
          'Mes réclamations pour cette commande')}
        {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
        {renderListReclamations}
      </div>
    );
  }
}
